module.exports = __webpack_public_path__ + "img/1.a5d6fa57.png";